module.exports = __webpack_public_path__ + "static/media/cs1.f760017f.jpg";